var _excluded = ["src", "alt", "loading"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Box from '../Box/Box';
var StretchedImg = styled.img.withConfig({
  displayName: "Image__StretchedImg",
  componentId: "sc-hzipw1-0"
})(["display:block;width:100%;"]);
/**
 * @component
 * Renders an image with optional sizing props.
 */

var Image = function Image(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      loading = _ref.loading,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Box, props, /*#__PURE__*/React.createElement(StretchedImg, {
    src: src,
    alt: alt,
    loading: loading || 'eager'
  }));
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired
};
export default Image;